import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">안전 정보 서비스</h3>
            <ul className="footer-links">
              <li><a href="https://www.safe182.go.kr" target="_blank" rel="noopener noreferrer">안전Dream 아동·여성·장애인 경찰지원센터</a></li>
              <li><a href="https://www.safetydata.go.kr" target="_blank" rel="noopener noreferrer">국가안전정보 통합공개시스템</a></li>
              <li><a href="https://www.youtube.com/watch?v=YeP3WEyPDt0" target="_blank" rel="noopener noreferrer">안전교육 영상</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">서비스 안내</h3>
            <p>이 웹사이트는 울산 지역 실종자 정보와 재난문자를 확인할 수 있는 서비스입니다.</p>
            <p>실종자 정보는 경찰청 안전Dream 사이트와 연동됩니다.</p>
            <p>재난문자 정보는 행정안전부 재난문자 서비스와 연동됩니다.</p>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">긴급 연락처</h3>
            <ul className="emergency-contacts">
              <li><strong>실종자 신고:</strong> 182</li>
              <li><strong>긴급 상황 (경찰):</strong> 112</li>
              <li><strong>화재, 구조, 구급:</strong> 119</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} 안전정보 통합 서비스. All Rights Reserved.</p>
          <p>본 서비스는 공공데이터를 활용한 서비스입니다.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;